import * as React from 'react';

import { GLOBAL_INPUT_CLASS } from '../../../core/Input';
import { splitClasses } from '../../utils';
import { useControl, Model } from '..';
import { Input } from '../shared';

declare module '../../Controls/hkt' {
    interface URIControlsToKind {
        'input': IInputProps
    }
}

type IInputProps = {
    name: string,
    onChange: (value: string, name: string) => void,
    value?: string,
    placeholder?: string,
    disabled?: boolean,
    onFocus?: () => void,
    onBlur?: () => void,
    className?: string,
}

const basicModel: Model<string> = {
    empty: '',
    putIn: (x) => x,
    putOut: (x) => x,
}

const Control = React.forwardRef<HTMLInputElement, IInputProps>(({ 
    name,
    onChange,
    value = '',
    disabled = false,
    placeholder = '',
    onFocus = () => {},
    onBlur = () => {},
    className,
}, ref) => {

    const {
        value: localValue,
        displayValue,
        inoutput,
    } = useControl(basicModel, value);

    const selfChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const x = e.target.value;
        inoutput(x);
    }

    React.useEffect(() => {
        onChange(localValue, name);
    }, [localValue]);

    return (
        <Input
            name={name}
            className={splitClasses(GLOBAL_INPUT_CLASS, className)}
            onChange={selfChange}
            disabled={disabled}
            value={displayValue}
            placeholder={placeholder}
            ref={ref}
            onFocus={onFocus}
            onBlur={onBlur}
        />
    );
});

export default Control;
